<nb-card class="confirmation-dialog">
  <nb-card-header class="confirmation-dialog-header">
    <div class="header-content">
      <nb-icon 
        *ngIf="icon" 
        [icon]="icon" 
        [status]="iconStatus"
        class="dialog-icon">
      </nb-icon>
      <h4 class="dialog-title">{{ title }}</h4>
    </div>
  </nb-card-header>

  <nb-card-body class="confirmation-dialog-body">
    <p class="dialog-message" [innerHTML]="message"></p>
  </nb-card-body>

  <nb-card-footer class="modal-footer">
    <div class="button-group">
      <button 
        nbButton 
        status="basic" 
        size="medium"
        type="button"
        (click)="onCancel()">
        {{ cancelButtonText }}
      </button>
      <button 
        nbButton 
        [status]="confirmButtonStatus" 
        size="medium"
        class="confirm-button"
        (click)="onConfirm()">
        {{ confirmButtonText }}
      </button>
    </div>
  </nb-card-footer>
</nb-card>
